import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {Field} from '@app/interfaces';

@Component({
    selector: 'app-form-input-multi-dropdown',
    templateUrl: './form-input-multi-dropdown.component.html',
    styleUrls: ['./form-input-multi-dropdown.component.scss'],
    standalone: false
})
export class FormInputMultiDropdownComponent implements OnInit, AfterViewInit {
  @Input() control: AbstractControl;
  @Input() formGroup: FormGroup;
  @Input() field: Field<number>;

  /** BRIEFD-7272: ng-multiselect-dropdown's own template renders the real
   *  focusable element (a `div[tabindex=0]`) inside its own view, which our
   *  template has no way to bind an attribute onto directly — an
   *  `[attr.aria-label]` placed on the `<ng-multiselect-dropdown>` host tag
   *  itself lands on a non-focusable wrapper and is never picked up as the
   *  accessible name of the div a screen reader actually lands on. The
   *  library also exposes no aria-label/id setting (see IDropdownSettings).
   *  So this reaches into its rendered DOM once after view init and sets the
   *  attribute directly — same end result as the native-element
   *  `[attr.aria-label]="field.config.label"` pattern BRIEFD-7216 used on
   *  the date field, just applied imperatively since there's no template
   *  hook for it here. Safe to key off `field.config.label` alone (no id
   *  uniqueness needed) even when this field type repeats on one page. */
  @ViewChild('multiselectHost', {read: ElementRef}) private multiselectHost?: ElementRef<HTMLElement>;

  public dropdownFilterSettings = {
    singleSelection: false,
    defaultOpen: false,
    idField: 'value',
    textField: 'name',
    enableCheckAll: false,
    itemsShowLimit: 2,
    allowSearchFilter: false,
  };

  constructor(private renderer: Renderer2) {
  }

  ngOnInit(): void {
    if (!this.control.value && this.field.value) {
      this.control.setValue(this.field.value);
    }
  }

  ngAfterViewInit(): void {
    const focusable = this.multiselectHost?.nativeElement.querySelector('.multiselect-dropdown');

    if (focusable && this.field?.config?.label) {
      this.renderer.setAttribute(focusable, 'aria-label', this.field.config.label);
    }
  }
}
